/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_LeadInputs */

const en_portalsignin_lead = /** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the email address your agency has on file. We will send you a sign-in link, so you do not need a password.`)
};

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const ar_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const he_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const ur_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const es_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const fr_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const de_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const pt_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const hi_portalsignin_lead = en_portalsignin_lead;

/** @type {(inputs: Portalsignin_LeadInputs) => LocalizedString} */
const bn_portalsignin_lead = en_portalsignin_lead;

/**
* | output |
* | --- |
* | "Enter the email address your agency has on file. We will send you a sign-in link, so you do not need a password." |
*
* @param {Portalsignin_LeadInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_lead = /** @type {((inputs?: Portalsignin_LeadInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_LeadInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_lead(inputs)
	if (locale === "he") return he_portalsignin_lead(inputs)
	if (locale === "ur") return ur_portalsignin_lead(inputs)
	if (locale === "es") return es_portalsignin_lead(inputs)
	if (locale === "fr") return fr_portalsignin_lead(inputs)
	if (locale === "de") return de_portalsignin_lead(inputs)
	if (locale === "pt") return pt_portalsignin_lead(inputs)
	if (locale === "hi") return hi_portalsignin_lead(inputs)
	if (locale === "bn") return bn_portalsignin_lead(inputs)
	return /** @type {LocalizedString} */ ("Enter the email address your agency has on file. We will send you a sign-in link, so you do not need a password.")
});